/* eslint-disable jsx-a11y/aria-role */
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { TextLink, TextLinkCaret } from '@vds/buttons';
import { Line } from '@vds/lines';
import { Col, Row } from '@vds/grids';
import { ModalBody, ModalFooter, ModalTitle } from '@vds/modals';

import { Body } from '../../../Typography/index';
import globalStyleProps from '../../../../../assets/css/preprocess/global.scss';
import '../../mobileCart.css';

import { VDSModal as Modal } from '../../../Modal/VDSModal';
import { viewport, getAPPID, isPreorder, checkIsMidnight, getUrlName } from '../../../Helpers';
import DueToday from './dueToday';
import DueMonthly from './dueMonthly';
import OneTimeChargesDiscounts from '../../redesign/component/OneTimeChargesDiscounts';
import { miniCartBackHandler, isDisplayOneTimeCharges, isHideViewCart, isSaveCartDisplay } from '../../MiniCartUtils';

const MobileCart = (props) => {
  const [displayModal, setDisplayModal] = useState(false);
  const { dueMonthlyProd, dueMontTotalAAL, dueMontAmount, depletionType, dueTodayList, dueTodayAmount, plansReferenceData, disneyPromoHelperText } =
    props;

  const type = viewport();
  const appId = getAPPID();
  let styleVal = {};
  if (type === 'mfapp') {
    styleVal = { margin: '0 !important' };
  }
  styleVal.maxHeight = globalStyleProps?.mycartNavbarHeight || '68px';

  const currentPageName = getUrlName(window.location.pathname);
  const hideViewCart = isHideViewCart(currentPageName);
  const isSaveCart = isSaveCartDisplay(currentPageName, appId);
  const isOneTimeCharges = isDisplayOneTimeCharges(currentPageName, depletionType?.indexOf('O') > -1 ? 'Professional SetUp' : 'Self SetUp');

  let dueMonthlyContent = '';
  if (appId === 'AAL' && dueMonthlyProd) {
    if (checkIsMidnight()) {
      dueMonthlyContent = ` $${dueMontTotalAAL !== null && dueMontTotalAAL !== undefined && dueMontTotalAAL !== '' ? parseFloat(dueMontTotalAAL || 0.0).toFixed(2) : ''}/mo`;
    } else {
      dueMonthlyContent = ` $${dueMontAmount !== null && dueMontAmount !== undefined && dueMontAmount !== '' ? parseFloat(dueMontAmount || 0.0).toFixed(2) : ''}/mo`;
    }
  }

  const showCartDetails = () => {
    setDisplayModal(!displayModal);
  };

  const handleOpenChange = (val) => {
    if (!val) {
      setDisplayModal(!displayModal);
    }
  };

  const goBack = (e) => {
    e.preventDefault();

    if (type === 'mobile' || type === 'mfapp' || type === 'tablet') {
      miniCartBackHandler(currentPageName, appId, props.history);
    } else {
      props.history.goBack();
    }
  };

  const showSaveCartDetails = () => {
    props.getShowCartStatus(true);
  };

  return (
    <React.Fragment>
      <div className="fullWidth" style={styleVal}>
        <div className="border_CC onlyBottomBorder height72">
          <Row className="justify-space-between ">
            <Col colSizes={{ mobile: 2, tablet: 3, desktop: 1 }} style={{ padding: '22px 0px 12px 30px' }} className="alignItemsCenter">
              <TextLinkCaret surface="light" disabled={false} iconPosition="left" ariaLabel="back" onClick={(e) => goBack(e)} />
            </Col>

            <Col colSizes={{ mobile: 2, tablet: 6, desktop: 1 }} className="pad12 onlyTopPad onlyTopMargin textAlignLeft">
              <div style={{ padding: '0 0 4px' }}>
                <Body size="small" color="#6F7171">
                  {isPreorder() ? 'Due at shipment' : 'Due today'}
                </Body>
              </div>
              <div id="dueTodayAmount" role="text">
                <Body size="large">
                  {`$${
                    dueTodayList && dueTodayAmount !== null && dueTodayAmount !== undefined && dueTodayAmount !== ''
                      ? parseFloat(dueTodayAmount || 0.0).toFixed(2)
                      : ''
                  }`}
                </Body>
              </div>
            </Col>
            <Col colSizes={{ mobile: 2, tablet: 4, desktop: 1 }} className="pad12 onlyTopPad onlyTopMargin textAlignLeft">
              <div style={{ padding: '0 0 4px' }}>
                <Body size="small" color="#6F7171">
                  Due monthly
                </Body>
              </div>
              <div id="dueMonthlyAmount">
                <Body size="large">{dueMonthlyContent}</Body>
              </div>
            </Col>
            <Col colSizes={{ mobile: 2, tablet: 4, desktop: 1 }} className="widthAutoImp">
              <Col colSizes={{ mobile: 2, tablet: 6, desktop: 1 }} className="textCenter pad12 onlyTopPad fontSize_2" style={{ marginRight: '10px' }}>
                {!hideViewCart && (
                  <TextLink
                    ariaLabel="View Cart Button"
                    onClick={() => showCartDetails()}
                    onKeyDown={() => showCartDetails()}
                    tabIndex="0"
                    type="standAlone"
                    id="ViewCart"
                  >
                    View Cart
                  </TextLink>
                )}
                {isSaveCart && (
                  <TextLink
                    ariaLabel="Save Cart"
                    onClick={() => showSaveCartDetails()}
                    onKeyDown={() => showSaveCartDetails()}
                    tabIndex="0"
                    type="inline"
                    size="small"
                    id="SaveCart"
                  >
                    Save cart
                  </TextLink>
                )}
              </Col>
            </Col>
          </Row>
        </div>
      </div>

      {displayModal && (
        <Modal ariaLabel="Order Summary" opened={displayModal} onOpenedChange={handleOpenChange} disableOutsideClick={false}>
          <ModalTitle>Order Summary</ModalTitle>
          <ModalBody>
            <section>
              <DueToday {...props} />

              <Line type="secondary" surface="light" />

              <DueMonthly
                dueMontAmount={dueMontAmount}
                dueMonthlyList={props.dueMonthlyList}
                dueMonthlyProd={dueMonthlyProd}
                dueMonthlyTaxes={props.dueMonthlyTaxes}
                plansReferenceData={plansReferenceData}
                planPerks={props.planPerks}
                whwDueMontly={props?.whwDueMontly}
                dueMontTotalAAL={dueMontTotalAAL}
                disneyPromoHelperText={disneyPromoHelperText}
              />
              <OneTimeChargesDiscounts plansReferenceData={plansReferenceData} isOneTimeCharges={isOneTimeCharges} appId={appId} />
            </section>
          </ModalBody>

          <ModalFooter
            buttonData={{
              primary: {
                width: '100%',
                children: 'Close',
                onClick: () => handleOpenChange(false),
              },
            }}
          />
        </Modal>
      )}
    </React.Fragment>
  );
};

MobileCart.propTypes = {
  dueMontTotalAAL: PropTypes.string,
  dueTodayAmount: PropTypes.number,
  dueTodayList: PropTypes.object,
  plansReferenceData: PropTypes.object,
  dueMontAmount: PropTypes.string,
  dueMonthlyList: PropTypes.any,
  dueMonthlyProd: PropTypes.object,
  dueMonthlyTaxes: PropTypes.number,
  history: PropTypes.object,
  getShowCartStatus: PropTypes.func,
  depletionType: PropTypes.string,
  planPerks: PropTypes.array,
  whwDueMontly: PropTypes.array,
  disneyPromoHelperText: PropTypes.string,
};
export default withRouter(MobileCart);
